import {
  ADD_ADMIN_WALLET_BALANCE,
  ADD_ADMIN_WALLET_BALANCE_FAILED,
  ADD_ADMIN_WALLET_BALANCE_SUCCEED,
  FETCH_ALL_ERR_ERC20,
  FETCH_ALL_ERR_ERC20_SUCCEED,
  FETCH_ALL_ERR_ERC20_FAILED,
  FETCH_ALL_ERR_TOMO_ERC20,
  FETCH_ALL_ERR_TOMO_ERC20_SUCCEED,
  FETCH_ALL_ERR_TOMO_ERC20_FAILED,
  FETCH_ADMIN_BALANCE,
  FETCH_ADMIN_BALANCE_SUCCEED,
  FETCH_ADMIN_BALANCE_FAILED,
  FETCH_ADMIN_WALLET,
  FETCH_ADMIN_WALLET_SUCCEED,
  FETCH_ADMIN_WALLET_FAILED,
  MIGRATE_BTC,
  MIGRATE_BTC_SUCCEED,
  MIGRATE_BTC_FAILED,
  MIGRATE_ETH,
  MIGRATE_ETH_SUCCEED,
  MIGRATE_ETH_FAILED,
  MIGRATE_ERC20,
  MIGRATE_ERC20_SUCCEED,
  MIGRATE_ERC20_FAILED,
  FIX_ERR_ERC20,
  FIX_ERR_ERC20_SUCCEED,
  FIX_ERR_ERC20_FAILED,
  FIX_ERR_TOMO_ERC20,
  FIX_ERR_TOMO_ERC20_SUCCEED,
  FIX_ERR_TOMO_ERC20_FAILED,
  SET_ADMIN_TRANSFER,
  SET_ADMIN_TRANSFER_SUCCESS,
  SET_ADMIN_TRANSFER_FAILED,
  FETCH_OWN_BALANCE,
  FETCH_OWN_BALANCE_FAILED,
  FETCH_OWN_BALANCE_SUCCESS,
} from './action_types';

export default {
  addAdminWalletBalanceAction: (params, callback) => ({
    type: ADD_ADMIN_WALLET_BALANCE,
    params,
    callback,
  }),
  addAdminWalletBalanceActionSucceed: (data, totalCount, callback) => ({
    type: ADD_ADMIN_WALLET_BALANCE_SUCCEED,
    data,
    totalCount,
    callback,
  }),
  addAdminWalletBalanceActionFailed: (err) => ({
    type: ADD_ADMIN_WALLET_BALANCE_FAILED,
    err,
  }),

  fetchAllErrERC20Action: (params, callback) => ({
    type: FETCH_ALL_ERR_ERC20,
    params,
    callback,
  }),
  fetchAllErrERC20ActionSucceed: (data, totalCount, callback) => ({
    type: FETCH_ALL_ERR_ERC20_SUCCEED,
    data,
    totalCount,
    callback,
  }),
  fetchAllErrERC20ActionFailed: (err) => ({
    type: FETCH_ALL_ERR_ERC20_FAILED,
    err,
  }),

  fetchAllErrTomoERC20Action: (params, callback) => ({
    type: FETCH_ALL_ERR_TOMO_ERC20,
    params,
    callback,
  }),
  fetchAllErrTomoERC20ActionSucceed: (data, totalCount, callback) => ({
    type: FETCH_ALL_ERR_TOMO_ERC20_SUCCEED,
    data,
    totalCount,
    callback,
  }),
  fetchAllErrTomoERC20ActionFailed: (err) => ({
    type: FETCH_ALL_ERR_TOMO_ERC20_FAILED,
    err,
  }),

  fetchAdminBalancesAction: (params, callback) => ({
    type: FETCH_ADMIN_BALANCE,
    params,
    callback,
  }),
  fetchAdminBalancesActionSucceed: (data, totalCount, callback) => ({
    type: FETCH_ADMIN_BALANCE_SUCCEED,
    data,
    totalCount,
    callback,
  }),
  fetchAdminBalancesActionFailed: (err) => ({
    type: FETCH_ADMIN_BALANCE_FAILED,
    err,
  }),

  fetchAdminWalletAction: (params, callback) => ({
    type: FETCH_ADMIN_WALLET,
    params,
    callback,
  }),
  fetchAdminWalletActionSucceed: (data, totalCount, callback) => ({
    type: FETCH_ADMIN_WALLET_SUCCEED,
    data,
    totalCount,
    callback,
  }),
  fetchAdminWalletActionFailed: (err) => ({
    type: FETCH_ADMIN_WALLET_FAILED,
    err,
  }),

  migrateBTCAction: (params, callback) => ({
    type: MIGRATE_BTC,
    params,
    callback,
  }),
  migrateBTCActionSucceed: (data, totalCount, callback) => ({
    type: MIGRATE_BTC_SUCCEED,
    data,
    totalCount,
    callback,
  }),
  migrateBTCActionFailed: (err) => ({
    type: MIGRATE_BTC_FAILED,
    err,
  }),

  migrateETHAction: (params, callback) => ({
    type: MIGRATE_ETH,
    params,
    callback,
  }),
  migrateETHActionSucceed: (data, totalCount, callback) => ({
    type: MIGRATE_ETH_SUCCEED,
    data,
    totalCount,
    callback,
  }),
  migrateETHActionFailed: (err) => ({
    type: MIGRATE_ETH_FAILED,
    err,
  }),

  migrateERC20Action: (params, callback) => ({
    type: MIGRATE_ERC20,
    params,
    callback,
  }),
  migrateERC20ActionSucceed: (data, totalCount, callback) => ({
    type: MIGRATE_ERC20_SUCCEED,
    data,
    totalCount,
    callback,
  }),
  migrateERC20ActionFailed: (err) => ({
    type: MIGRATE_ERC20_FAILED,
    err,
  }),

  fixErrERC20Action: (params, callback) => ({
    type: FIX_ERR_ERC20,
    params,
    callback,
  }),
  fixErrERC20ActionSucceed: (data, totalCount, callback) => ({
    type: FIX_ERR_ERC20_SUCCEED,
    data,
    totalCount,
    callback,
  }),
  fixErrERC20ActionFailed: (err) => ({
    type: FIX_ERR_ERC20_FAILED,
    err,
  }),

  fixErrTomoERC20Action: (params, callback) => ({
    type: FIX_ERR_TOMO_ERC20,
    params,
    callback,
  }),
  fixErrTomoERC20ActionSucceed: (data, totalCount, callback) => ({
    type: FIX_ERR_TOMO_ERC20_SUCCEED,
    data,
    totalCount,
    callback,
  }),
  fixErrTomoERC20ActionFailed: (err) => ({
    type: FIX_ERR_TOMO_ERC20_FAILED,
    err,
  }),

  setAdminTransfer: (params) => ({
    type: SET_ADMIN_TRANSFER,
    params,
  }),
  setAdminTransferSuccess: (data) => ({
    type: SET_ADMIN_TRANSFER_SUCCESS,
    data,
  }),
  setAdminTransferFailed: (err) => ({
    type: SET_ADMIN_TRANSFER_FAILED,
    err,
  }),
};
